//Fixes issues with failing hashlinks by scrolling multiple times to beat layout/app scroll resets
(function () {
    const hash = window.location.hash;
    if (!hash) return;

    // Prevent native browser scroll
    history.replaceState(null, '', window.location.pathname + window.location.search);

    document.addEventListener('DOMContentLoaded', function () {
        const target = document.querySelector(hash);
        if (!target) return;

        // scroll multiple times to beat layout/app scroll resets
        let attempts = 0;
        const maxAttempts = 8;
        const interval = 300;

        const scrollTimer = setInterval(() => {
            if (attempts >= maxAttempts) {
                clearInterval(scrollTimer);
                return;
            }

            // only scroll if element is in layout
            if (target.offsetParent !== null) {
                target.scrollIntoView({ behavior: 'smooth' });
            }

            attempts++;
        }, interval);
    });
})();